import { render } from "./AuthList.vue?vue&type=template&id=0488f954&scoped=true"
import script from "./AuthList.vue?vue&type=script&lang=js"
export * from "./AuthList.vue?vue&type=script&lang=js"

import "./AuthList.vue?vue&type=style&index=0&id=0488f954&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0488f954"

export default script